import { css, cva } from "@stubhub/broadway-foundation/css";

export const officialMarketplaceWrapper = css({
  marginBlock: "primitives.50",
  marginBlockStart: "-primitives.50",
});

export const headerContainer = cva({
  base: {
    "& > div": {
      position: "relative",
      zIndex: "[2]",
    },
  },
  variants: {
    view: {
      calendar: {
        tablet: {
          marginBlockEnd: "primitives.200",
        },
      },
      default: {
        tablet: {
          marginBlockEnd: "primitives.600",
        },
      },
    },
  },
  defaultVariants: {
    view: "default",
  },
});
